import { forwardRef } from 'react';
import * as Radix from '@radix-ui/react-popover';
import { cn } from '../lib/cn';

export const Popover = Radix.Root;
export const PopoverTrigger = Radix.Trigger;
export const PopoverAnchor = Radix.Anchor;
export const PopoverClose = Radix.Close;

export const PopoverContent = forwardRef<
  React.ElementRef<typeof Radix.Content>,
  React.ComponentPropsWithoutRef<typeof Radix.Content>
>(function PopoverContent(
  { className, sideOffset = 8, align = 'start', ...rest },
  ref,
) {
  return (
    <Radix.Portal>
      <Radix.Content
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        className={cn(
          'z-50 min-w-[200px] rounded-md border border-border-soft bg-surface p-3 text-base text-ink shadow-md outline-none',
          'data-[state=open]:animate-fade-in',
          className,
        )}
        {...rest}
      />
    </Radix.Portal>
  );
});
